import * as yup from 'yup';

export const validation = yup.object().shape({
  cli_name: yup.string().required("El nombre es obligatorio"),
  cli_apellido: yup.string().required("El apellido es obligatorio"),
  cli_cp: yup.string().optional(),
  cli_email: yup.string().email("Email inválido").required("El email es obligatorio"),
  cli_pass: yup.string().min(8, "Mínimo 8 caracteres").required("La contraseña es obligatoria"),
  cli_pass_confirm: yup.string()
    .oneOf([yup.ref('cli_pass'), null], 'Las contraseñas no coinciden')
    .required("Confirmar contraseña es obligatorio")
});
